import template from './termsAddOnModal.html';
import * as _ from 'lodash';


class TermsAddOnModalController {
    /* @ngInject */
    constructor($uibModal, dataContext, constants, $log, alertService) {
        this.$modal = $uibModal;
        this.$log = $log;
        this.dataContext = dataContext;
        this.constants = constants;
        this.data = this.config.data;
        this.$close = this.config.close;
        this.$dismiss = this.config.dismiss;
        this.alertService = alertService;
        this.isAIDAddon = false;
        this.isAIVideoSearch = false;
    }

    close() {
        this.$dismiss();
    }

    $onInit() {
        if (this.data.isBundleEnroll) {
            this.isBundleEnroll = true;
            this.bundle = this.data.bundle;
            this.bundleMonthlyPrice = '10';
            this.bundleDisplayName = 'Next Gen Suite';
            return;
        }
        if (this.data.isAIVideoSearch) {
            this.isAIVideoSearch = true;
            this.rmr = this.data.aiVideoSearchAddon.Price;
            return;
        }
        if (!_.isNull(this.data.aidAddonServicePlanSelected)) {
            this.rmr = this.data.aidAddonServicePlanSelected.price;
            this.isAIDAddon = true;
        }
        else {
            this.rmr = this.data.safetyButtonAddOn[0].Price;
        }        
    }

    enrollBundle() {
        this.$close();
        const bundleId = this.bundle.AddonBundleId || this.bundle.addonBundleId;
        this.dataContext.account.enrollAddonBundle(bundleId).then((result) => {
            if (result && result.success) {
                const modalInstance = this.$modal.open({
                    template: '<fp-success-add-on-modal config="config"></fp-success-add-on-modal>',
                    controller: ($scope) => {
                        'ngInject';
                        $scope.config = {
                            data: {
                                bundleEnroll: true,
                                bundleName: this.bundleDisplayName
                            },
                            close: modalInstance.close,
                            dismiss: modalInstance.dismiss
                        };
                    },
                    size: 'lg'
                });
            } else {
                alert((result && result.message) || 'Error enrolling in bundle.');
            }
        });
    }

    enroll() {
        if (this.isAIVideoSearch) {
            this.$close();
            return;
        }
        this.close();
        if (this.isAIDAddon) {
            const numberOFCameras = this.data.aidAddonServicePlanSelected.servicePlanName.substring(0, 2).trim();
            const addOnInfo = {
                oldQuantity: this.data.oldQuantity,
                newQuantity: parseInt(numberOFCameras),
                addOn: 'AIDeterrence', // addOn name to add safety button
                addOnId: this.data.aidAddonServicePlanSelected.addonId
            };
            this.dataContext.account.setAIDAddOns(addOnInfo).then((result) => {
                if (result) {
                    const modalInstance = this.$modal.open({
                        template: '<fp-success-add-on-modal config="config"></fp-success-add-on-modal>',
                        controller: ($scope) => {
                            'ngInject';
                            $scope.config = {
                                data: {
                                    isAIDAddon: this.isAIDAddon
                                },
                                close: modalInstance.close,
                                dismiss: modalInstance.dismiss
                            };
                        },
                        size: 'lg'
                    });
                }
            });
        }
        else {
            const addOnInfo = {
                oldQuantity: this.data.oldQuantity,
                newQuantity: this.data.newQuantity,
                addOn: 'Noonlight' // addOn name to add safety button
            };
            this.dataContext.account.addAccountAddOns(addOnInfo).then((result) => {
                if (result) {
                    const modalInstance = this.$modal.open({
                        template: '<fp-success-add-on-modal config="config"></fp-success-add-on-modal>',
                        controller: ($scope) => {
                            'ngInject';
                            $scope.config = {
                                data: {

                                },
                                close: modalInstance.close,
                                dismiss: modalInstance.dismiss
                            };
                        },
                        size: 'lg'
                    });
                }
            });
        }       
        
    }
    
}

export default {
    template: template,
    bindings: {
        config: '<',
        safetyButtonAddOn: '<',
        oldQuantity: '<',
        newQuantity: '<',
        aidAddonServicePlanSelected: '<'
    },
    controller: TermsAddOnModalController
};
